/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Etaf_InvalidInputs */

const en_error_etaf_invalid = /** @type {(inputs: Error_Etaf_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An e-TAF cannot be opened for this organization:`)
};

/**
* | output |
* | --- |
* | "An e-TAF cannot be opened for this organization:" |
*
* @param {Error_Etaf_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_etaf_invalid = /** @type {((inputs?: Error_Etaf_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Etaf_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_etaf_invalid(inputs)
});